import { connect } from 'react-redux'

import LandingPage from './landingPage'
import fetchLandingPageContent from '../../../common/actions/fetchLandingPageContent'

const mapStateToProps = (state) => {
  const { html, css } = state.landingPage
  const { currentSite, baseUrl } = state.common
  const { user } = state

  return {
    html,
    css,
    currentSite,
    user,
    baseUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const LandingPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage)

LandingPageContainer.loadData = (store, parsedUrl, opts) => {
  return store.dispatch(fetchLandingPageContent(parsedUrl, opts))
}

export default LandingPageContainer



// WEBPACK FOOTER //
// ./client/pages/landing/landingPageContainer.js